export enum EPhotoSource {
  UNKNOWN = "UNKNOWN",
  VOLTINSTALL_CAMERA = "VOLTINSTALL_CAMERA",
  VOLTINSTALL_GALLERY = "VOLTINSTALL_GALLERY",
}

export function findSource(source: string): EPhotoSource {
  return EPhotoSource[source as EPhotoSource] ?? EPhotoSource.UNKNOWN;
}
